export const Articles_REQUEST = 'Articles_REQUEST';
export const Articles_SUCCESS = 'Articles_SUCCESS';
export const Articles_FAIL = 'Articles_FAIL';